export default "__VITE_ASSET__CXSTOzxt__"